(function() {
  'use strict';

  function ReportViewFiltersController(
    $scope,
    $rootScope,
    $translate,
    Form,
    Security,
    ReportWrapperService
  ) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.reportViewer = ReportWrapperService.reportViewer;
      Security.hasPermission('reports.edit.own')
        .then(function(data) {
          ctrl.canEditReport = data;
        });

      ctrl.report = {
        title: ctrl.reportViewer.title,
        subtitle: ctrl.reportViewer.subtitle
      };
    };

    ctrl.showDatesForm = function() {
      ctrl.dates = ctrl.dates || {};
      var leftForm = new Form();

      leftForm.addField({
        id: 'after',
        type: 'date',
        label: $translate.instant('Events after'),
        required: true
      });

      var rightForm = new Form();
      rightForm.addField({
        id: 'before',
        type: 'date',
        label: $translate.instant('Events before'),
        required: true
      });

      ctrl.leftForm = leftForm;
      ctrl.rightForm = rightForm;
      ctrl.showDates = true;
    };

    ctrl.updateDates = function() {
      ctrl.reportViewer.list.searchModel.filteredBy.before = ctrl.dates.before;
      ctrl.reportViewer.list.searchModel.filteredBy.after = ctrl.dates.after;
      ctrl.reportViewer.list.defaultFilter.before = ctrl.dates.before;
      ctrl.reportViewer.list.defaultFilter.after = ctrl.dates.after;
      ctrl.showDates = false;
      ctrl.reportViewer.list.doLoadItems()
        .then(function() {
          $rootScope.$broadcast('reportsviewer.listUpdated');
        });
    };

    ctrl.applyDates = function() {
      $rootScope.$broadcast('reportsviewer.listUpdated');
    };

    ctrl.resetForn = function() {
      $rootScope.$broadcast('reportsviewer.listUpdated');
    };

    $scope.$on('reportsviewer.viewUpdated', function() {
      ctrl.reportViewer = ReportWrapperService.reportViewer;
    });
  }

  ReportViewFiltersController.$inject = [
    '$scope',
    '$rootScope',
    '$translate',
    'FormsService',
    'SecurityService',
    'ReportWrapperService'


  ];

  angular.module('component.reports')
    .component('reportViewFilters', {
      controller: ReportViewFiltersController,
      controllerAs: 'reportViewFiltersCtrl',
      templateUrl: 'app/components/reports/layout.left.html',
      bindings: {
      }
    });
})();
